<ion-header class="free-bets-header">
  <user-section-title [sectionTitle]="'Freebets'"></user-section-title>
  <ion-toolbar
    mode="md"
    class=""      
    *ngIf="licenseType() !== LicenseTypes.Colombia && licenseType() !== LicenseTypes.ArgentinaCaba && !forbiddenFreebets()"
  >
    <ion-segment [value]="'online'" (ionChange)="onChangeHeader.emit($event.target.value)">
      <ion-segment-button role="button" tappable="" value="online">
        <!--{{'fbOnline' | translate}}-->ONLINE
      </ion-segment-button>

      <ion-segment-button role="button" tappable="" value="presencial" *ngIf="licenseType() !== 4">
        <!--{{'fbPresen' | translate}}-->PRESENCIAL
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>